import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useResourcesContext } from "app/contexts/resources";

export function DenominacionSocialSelect({
  label = "Denominación social",
  value = 0,
  onChange = () => {},
  disabled = false,
}) {
  const { denominacionesSociales } = useResourcesContext();

  return (
    <FormControl size="small" fullWidth required>
      <InputLabel id="denominacion-social-label">{label}</InputLabel>

      <Select
        labelId="denominacion-social-label"
        label={label}
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
      >
        {denominacionesSociales.results.map((denominacion) => (
          <MenuItem
            key={denominacion.denominacion_social_id}
            value={denominacion.denominacion_social_id}
          >
            {denominacion.denominacion_social_nombre}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
